var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgItaly = function SvgItaly(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 37,
    viewBox: "0 0 33 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m25.474 32.206-.994-.887 1.128-2.659-1.37-3.943-6.462-4.048-4.957-4.234-3.023-5.305-3.358-1.35-2.969 2.329L.917 7.637l4.58-4.922 3.4.132 2.78-1.852 3.681-.569.9 1.628 3.305.29-.752 2.832-2.929 1.019-.228 3.638 3.345 2.778 2.364 4.658 4.205.979.322.555-.886.794 3.439 1.945 2.364 1.402 1.277 1.628-.753 1.072-1.37-1.628-1.8-.74-1.37 2.13 1.464 1.812-.094 1.402-2.687 3.586ZM14.807 32.06l.47-1.72 4.246.649 3.264-.94.282.516-1.37 2.752.43 1.059-.9 1.257-6.422-3.573ZM4.974 21.542l3.022-1.336 1.465 2.83-.712 5.028-1.317-.423-.846 1.072-1.277-.834.47-3.4-1.047-1.813.242-1.124Z",
    stroke: "#282838",
    strokeMiterlimit: 10
  })));
};
export default SvgItaly;